import React, { useMemo } from 'react';

import { useGetDistributorAdmissionFeeAnalyticsQuery } from 'api/main';
import { texts } from 'utils/languages/fr';

import withProducts from './withProductSelectHOC';
import DataContainer from './DataContainer';

const dataSorter = (a, b) => {
    if (a.YEAR > b.YEAR) return 1;
    if (a.YEAR - b.YEAR) return -1;
    if (a.QUARTER > b.QUARTER) return 1;
    if (a.QUARTER < b.QUARTER) return -1;
    return 0;
};

const getMappedData = data => [...data].sort(dataSorter).map(d => +d.value.replace(/,/gi, ''));
const getMappedCategories = data =>
    [...data].sort(dataSorter).map(d => `Q-${d.QUARTER} '${(d.YEAR + '').slice(2)}`);

const AdmissionFeeData = props => {
    const { products, product, setProduct } = props;
    const selectedProductName = useMemo(
        () => (product === 'all' ? texts.ALL_1 : products.find(p => p.id === +product)?.name),
        [products, product]
    );

    const { data: admissionFeeData = { quarter_grouped_admission_fees: [] }, isLoading: loading } =
        useGetDistributorAdmissionFeeAnalyticsQuery({
            fundId: product === 'all' ? undefined : +product,
        });

    const series = useMemo(() => {
        const mappedData = getMappedData(admissionFeeData.quarter_grouped_admission_fees);
        return mappedData.length ? [{ name: selectedProductName, data: mappedData }] : [];
    }, [admissionFeeData, selectedProductName]);

    const categories = useMemo(
        () => getMappedCategories(admissionFeeData.quarter_grouped_admission_fees),
        [admissionFeeData]
    );

    return (
        <DataContainer
            title={texts.ADMISSION_FEE_COMMISSIONS}
            products={products}
            product={product}
            setProduct={setProduct}
            loading={loading}
            chartCategories={categories}
            chartSeries={series}
        />
    );
};

export default withProducts(AdmissionFeeData);
